import { Button, Flex, Tooltip } from 'antd'
import IconDelete from 'components/icons/IconDelete'
import IconDisable from 'components/icons/IconDisable'
import IconEdit from 'components/icons/IconEdit'
import IconEnable from 'components/icons/IconEnable'
import { useTranslation } from 'react-i18next'

interface IBaseTableActionProps {
  onDelete?: (record: unknown) => void
  onToggleStatus?: (record: unknown) => void
  onEdit?: (record: unknown) => void
  status?: boolean
}

function BaseTableAction(props: IBaseTableActionProps) {
  const { onDelete, onEdit, onToggleStatus, status } = props
  const { t } = useTranslation()

  return (
    <Flex gap={2}>
      <Flex flex={1} justify='flex-end'>
        {onDelete && (
          <Tooltip title={t('common.tooltips.delete')} placement={'top'}>
            <Button type='text' onClick={onDelete} icon={<IconDelete />} />
          </Tooltip>
        )}
      </Flex>
      <Flex flex={1} justify='flex-end'>
        {onEdit && (
          <Tooltip title={t('common.tooltips.edit')} placement={'top'}>
            <Button type='text' onClick={onEdit} icon={<IconEdit />} />
          </Tooltip>
        )}
      </Flex>
      <Flex flex={1} justify='flex-end'>
        {onToggleStatus && (
          <Tooltip title={status ? t('common.tooltips.disable') : t('common.tooltips.enable')} placement={'top'}>
            <Button type='text' onClick={onToggleStatus} icon={status ? <IconDisable /> : <IconEnable />} />
          </Tooltip>
        )}
      </Flex>
    </Flex>
  )
}

export default BaseTableAction
